export default (items) => {
	const itemsDOM = document.querySelectorAll(items);
	
	let targettedItems = []

	itemsDOM.forEach((itemDOM, index) => {
		let target = itemDOM;

		/** When item is not the target which should gain 'is-active' class */
		let dataTarget = itemDOM.getAttribute('data-target')
		if(dataTarget){
			if(dataTarget == 'parent') target = itemDOM.parentNode
		}else{

		}
		targettedItems.push(target)

		itemDOM.addEventListener('click', () => {
			targettedItems.forEach(x => x.classList.remove('is-active'))
			target.classList.add('is-active')
		})
	})
}